import ngAnnotate from '../../ngAnnotate.macro';
import template from './user_action_modal.html';

angular.module('bb.users').component('bbUserActionModal', {
  controller: UserActionModalController,
  controllerAs: 'vm',
  template,
});

function UserActionModalController(ModalService, userService, ErrorService) {
  const vm = this;

  vm.userActionModal = ModalService.userActionModal;
  vm.$onInit = () => {
    vm.page = 1;
  };

  vm.getActions = () => {
    vm.userActionModal.actions = null;
    if (vm.userActionModal.open) {
      userService
        .getUserActions(vm.userActionModal.userId, vm.page)
        .then(({ actions, count }) => {
          vm.userActionModal.actions = actions;
          vm.userActionModal.count = count;
        })
        .catch(err => {
          ErrorService.toastyHTTPErr(err);
        });
    }
  };

  vm.closeModal = () => {
    ModalService.closeUserActionModal();
  };
}

ngAnnotate(UserActionModalController);
